import { Controller } from "@hotwired/stimulus"

// Bouton retour « intelligent ».
//
// - S'il existe un historique de navigation (cas normal liste → détail, aussi
//   bien sur le web qu'en Hotwire Native où la webview est partagée par le
//   navigator), on dépile via history.back() : pop natif + restauration du
//   scroll, plutôt qu'une visite avant qui empilerait une 2e VC.
// - Sinon (deep-link, refresh, push notif, lien partagé, crawler), on laisse le
//   lien suivre son href : l'URL de secours fournie par le serveur (return_to
//   validé, sinon le dashboard).
export default class extends Controller {
  navigate(event) {
    if (window.history.length > 1) {
      event.preventDefault()
      window.history.back()
    }
  }
}
